import React, { Component } from "react";
import PropTypes from "prop-types";
import CodeAlert from "./CodeAlert";
import Home from "./Home";
import {
  ArrowBackIosOutlined,
  Close,
  SearchOutlined
} from "@material-ui/icons";
import { Box, CardHeader, Hidden, IconButton } from "@material-ui/core";
import { connect } from "react-redux";
import { goToBeginning } from "../../utils/scenario-manager";
import {
  checkAppointments,
  getCanceledReason,
  logOut,
  switchWidgetPatientArea
} from "../../utils/fetcher";
import { closeMainDialog, setReturnedValue } from "../../actions";

class ContentSMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenSideBar: true,
      isOpen: true,
      isOpenSearch: false,
      show: "rdv"
    };
  }

  handleCloseSearch() {
    this.setState(prevState => ({ isOpenSearch: !prevState.isOpenSearch }));
  }

  render() {
    const { classes } = this.props;
    return (
      <div
        className={classes?.container}
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#DBF0FE",
          position: "relative",
          display: "block"
        }}
      >
        <CardHeader
          subheader={
            <>
              {this.state.show !== "rdv" && (
                <IconButton
                  style={{
                    color: "#009EFF",
                    height: "25px",
                    width: "25px"
                  }}
                  onClick={() => {
                    this.setState({ show: "rdv" });
                  }}
                >
                  <ArrowBackIosOutlined />
                </IconButton>
              )}
            </>
          }
          action={
            <Box>
              <Hidden mdUp>
                <IconButton
                  onClick={() =>
                    this.setState(prevState => ({
                      isOpenSearch: !prevState.isOpenSearch
                    }))
                  }
                  style={{
                    color: "white",
                    height: "25px",
                    width: "25px",
                    backgroundColor: "#009EFF",
                    marginRight: 8
                  }}
                  aria-label="close"
                >
                  <SearchOutlined />
                </IconButton>
              </Hidden>

              <IconButton
                style={{
                  color: "white",
                  height: "25px",
                  width: "25px",
                  backgroundColor: "#009EFF",
                  marginRight: 8
                }}
                aria-label="close"
                onClick={() => {
                  this.setState({ show: "login" });
                }}
              >
                <img src="icons/person.svg" alt="icon" width={25} />
              </IconButton>

              <IconButton
                onClick={this.props.closeMainDialog}
                style={{
                  color: "white",
                  height: "25px",
                  width: "25px",
                  backgroundColor: "#009EFF"
                }}
                aria-label="close"
              >
                <Close />
              </IconButton>
            </Box>
          }
          style={{
            color: "#009EFF",
            padding: "20px 20px 0 20px"
          }}
        />

        {this.state.show && (
          <Home
            isOpenSearch={this.state.isOpenSearch}
            show={this.state?.show}
            ressourceRdv={this.props.dataSource["rdvSmsData"]}
            consignes={this.state?.consignes}
            goToBegining={this.props.goToBeginning}
          />
        )}

        <CodeAlert
          handleLogin={() => {
            this.setState({ show: "login" });
          }}
          handleSubmitCode={this.props.submitCode}
        />
      </div>
    );
  }
}

ContentSMS.propTypes = {
  dataSource: PropTypes.any,
  classes: PropTypes.any,
  goToBeginning: PropTypes.func,
  logOut: PropTypes.func,
  switchWidgetPatientArea: PropTypes.func,
  setReturnedValue: PropTypes.func,
  closeMainDialog: PropTypes.func,
  submitCode: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    steps: state.steps,
    activeStep: state.activeStep,
    enableBtn: state.btnState,
    itemBreadcrumbs: state.itemBreadcrumbs,
    user: state.user,
    showBtnNext: state.showBtnNext,
    isShowLang: state.configuration.isShowLang || false,
    configuration: state.configuration
  };
};

const mapDispatchToProps = dispatch => {
  return {
    submitCode: code => dispatch(checkAppointments(code)),
    getCanceledReason: () => dispatch(getCanceledReason()),
    setReturnedValue: value => dispatch(setReturnedValue(value)),
    closeMainDialog: () => dispatch(closeMainDialog()),
    logOut: () => dispatch(logOut()),
    switchWidgetPatientArea: () => dispatch(switchWidgetPatientArea()),
    goToBeginning: () => dispatch(goToBeginning())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentSMS);
